/**
 * Injecte un bloc `application/ld+json` dans le <head> via react-helmet-async.
 * Utiliser pour les données structurées Schema.org (WebSite, Event, Organization, etc.)
 */
import { Helmet } from 'react-helmet-async';

interface JsonLdProps {
  data: Record<string, unknown>;
}

export function JsonLd({ data }: JsonLdProps) {
  return (
    <Helmet>
      <script type='application/ld+json'>{JSON.stringify(data)}</script>
    </Helmet>
  );
}
